import React, {useEffect, useState} from 'react';
import {css, styled} from 'styled-components';
import {colors} from '../../styles/colors';
import DefaultText from './DefaultText';
import {useLocation, useNavigate} from 'react-router-dom';
import {getDevice} from 'utils/getDevice';
import DefaultImageView from './DefaultImageView';
import {minmax} from 'utils/minmax';
import {menuData} from 'data/data';

/**
 * 네비게이션 바 컴포넌트
 * 메뉴 네비게이션을 표시하는 사이드바 컴포넌트입니다.
 * @returns {JSX.Element} 네비게이션 바 컴포넌트
 */
const NavBar = () => {
  const navigate = useNavigate();
  const {pathname} = useLocation();

  const [selectMenu, setSelectMenu] = useState('');
  const [openMenu, setOpenMenu] = useState<string>('');

  const isPC = getDevice() === 'pc' ? true : false;

  useEffect(() => {
    const pageName = pathname.slice(1).toLowerCase();

    for (const main of Object.keys(menuData)) {
      if (pageName === main.toLowerCase()) {
        setSelectMenu(main);
      } else if (menuData[main]) {
        const sub = menuData[main]?.find(item =>
          pageName.includes(item.toLowerCase()),
        );

        sub && setSelectMenu(sub);
        sub && setOpenMenu(main);
      }
    }
  }, [pathname]);

  return (
    <Container $isPC={isPC ? 1 : 0}>
      {Object.keys(menuData).map((mainTitle, index) => (
        <MenuContainer key={mainTitle + index} $active={1} $isPC={isPC ? 1 : 0}>
          <MainTitleWrap
            style={{
              backgroundColor:
                !menuData[mainTitle] && selectMenu === mainTitle
                  ? colors.primary2
                  : 'transparent',
            }}
            onClick={() => {
              if (menuData[mainTitle]) {
                setOpenMenu(mainTitle);
              } else {
                navigate(`/${mainTitle}`);
              }
            }}>
            <DefaultText
              text={mainTitle}
              textStyle={{
                fontSize: minmax(22),
                color: colors.white,
                fontWeight: openMenu.includes(mainTitle) ? 500 : 400,
              }}
            />
            {mainTitle === 'announcements' && (
              <DefaultText
                as="span"
                text="announcementsMenuDetail"
                textStyle={{
                  fontSize: minmax(16),
                  color: colors.white,
                  fontWeight: openMenu.includes(mainTitle) ? 500 : 400,
                  marginLeft: minmax(3),
                  paddingTop: minmax(5),
                }}
              />
            )}
            {menuData[mainTitle] && (
              <DefaultImageView
                source={`images/common/nav_${
                  openMenu.includes(mainTitle) ? 'up' : 'down'
                }.png`}
                style={{
                  width: '10%',
                  marginLeft: 'auto',
                }}
              />
            )}
          </MainTitleWrap>

          {openMenu.includes(mainTitle) && (
            <SubList>
              {menuData[mainTitle]?.map((subTitle, index) => {
                return (
                  <SubItemWrap
                    key={subTitle + index}
                    style={{
                      backgroundColor:
                        selectMenu === subTitle
                          ? colors.primary2
                          : 'transparent',
                    }}
                    onClick={() => {
                      navigate(`/${subTitle}`);
                    }}>
                    <span className="dash">{'- '}</span>
                    <DefaultText
                      text={subTitle}
                      textStyle={{
                        fontSize: minmax(20),
                        color: colors.white,
                        fontWeight: selectMenu === subTitle ? 500 : 400,
                      }}
                    />
                  </SubItemWrap>
                );
              })}
            </SubList>
          )}
        </MenuContainer>
      ))}
    </Container>
  );
};

const Container = styled.ul<{$isPC: number}>`
  position: fixed;
  top: ${minmax(88)};
  left: 0;
  width: ${minmax(312)};
  height: calc(100vh - ${minmax(88)});
  padding-bottom: max(18px, min(2vw, 36px));
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #192c3e;
  overflow-y: scroll;

  // 스크롤바 삭제
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
  ${props =>
    props.$isPC === 0 &&
    css`
      width: 160px;
    `};
`;

const MenuContainer = styled.li<{$active?: number; $isPC: number}>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
`;

const MainTitleWrap = styled.div`
  width: 100%;
  padding: 0 5%;
  height: max(30px, min(3vw, 60px));
  display: flex;
  flex-direction: row;
  /* justify-content: space-between; */
  align-items: center;
`;

const SubList = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #223c54;
`;

const SubItemWrap = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: max(6px, min(0.6vw, 12px)) 5%;
  .dash {
    color: ${colors.white};
    font-size: max(11px, min(1.2vw, 22px));
    white-space: pre;
  }
`;

export default NavBar;
